module.exports = __webpack_public_path__ + "static/label-ecc1d6dd79a51fe763a97851792740ce.mp4";